import React, { useEffect } from "react";
import { create } from "jss";
import rtl from "jss-rtl";
import {
  StylesProvider,
  jssPreset,
  makeStyles,
} from "@material-ui/core/styles";
import { CssBaseline, ThemeProvider, createMuiTheme } from "@material-ui/core";
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const shared = {
  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
  palette: {
    primary: {
      main: "#35C974",
    },
    secondary: {
      main: "#3ddf76",
    },
  },
};

const theme_rtl = createMuiTheme({
  direction: "rtl",
  ...shared,
});

const theme_ltr = createMuiTheme({
  direction: "ltr",
  ...shared,
  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
});

const useStyles = makeStyles({
  "@global": {
    "body,html": {
      overflowX: "hidden",
    },
  },
});

export default function Wrapper({ children, direction }) {
  useStyles();
  React.useEffect(
    (_) => {
      document.body.dir = direction;
    },
    [direction]
  );
  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={direction === "ltr" ? theme_ltr : theme_rtl}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StylesProvider>
  );
}
